import React, { useEffect } from "react";
import { Box, Card, CardMedia, CardContent, Container, Typography } from "@mui/material";
import MonthlyImageViewer from "../Components/MonthlyImagesViewer";

const LATEST_IMAGE = {
  src: "/imgs/monthly-newsletter/large-rectangle-poster-mcverse-2026-03-stats.png",
  alt: "MCVerse March 2026 Monthly Stats",
  title: "March 2026",
};

export default function MonthlyStats() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <main>
      <Container maxWidth="lg" sx={{ pt: 4, pb: 2 }}>
        {/* Latest month hero card */}
        <Card variant="outlined">
          <CardContent sx={{ pb: 1 }}>
            <Typography variant="h5" fontWeight={700}>
              {LATEST_IMAGE.title}
            </Typography>
          </CardContent>
          <CardMedia
            component="img"
            image={LATEST_IMAGE.src}
            alt={LATEST_IMAGE.alt}
            sx={{ width: "100%", height: "auto", display: "block" }}
          />
        </Card>
      </Container>

      {/* Full gallery */}
      <Container sx={{ py: 4 }} maxWidth="lg">
        <MonthlyImageViewer />
      </Container>
    </main>
  );
}
